<template>
	<div>
		<div class="title has-text-centered mt-30">ログイン</div>

		<div class="form has-text-centered">
			<div class="field mb-30">
				<div class="control">
					<input type="text" class="input" placeholder="メールアドレス" v-model="email">
				</div>
			</div>

			<!--
			<div class="field mb-30">
				<div class="control">
					<input type="password" class="input" placeholder="パスワード" v-model="password">
				</div>
			</div>
			-->

			<p class="help is-danger" v-show="loginError !== ''">{{ loginError }}</p>

			<button type="button" class="btn login-btn mt-30" @click="login">ログイン</button>
		</div>
	</div>
</template>

<script>
export default {
	name: 'Login',
	data() {
		return {
			email: '',
			password: '',
			isLoading: false,
			loginError: '',
		}
	},
	mounted() {
		this.$store.commit('basic', {
			key: 'isInAppBase',
			value: false,
		});
	},
	methods: {
		login: function() {
			this.loginError = '';
			this.$utils.toggleLoading();

			this.$auth.login(this.email, this.password)
				.then(() => {
					this.$router.push({ name:'dashboard' })
				})
				.catch((error) => {
					this.loginError = error.message;
				})
				.finally(() => {
					this.$utils.toggleLoading();
				}
			);
		},
	}
}
</script>

<style scoped>
.title {
	font-size: 18px;
}
.form {
	padding: 20px 40px;
}
.login-btn {
	width: 120px;
	margin: 0 auto;
}
</style>
